import JSONPretty from 'react-json-pretty';

export default {
  className: "VoucherErrorLog",
  limit: 10,
  showExport: false,
  showCreate: false,
  showUpdate: false,
  showDelete: false,
  bypassAccess: true,
  columns: [
    {
      columnName: "objectId",
  		type: "string"
    },
    {
      columnName: "methodName",
  		type: "string"
    },
    {
      columnName: "message",
  		type: "string",
      render: ({
        value,
        column,
        getTableData,
        object
      }) => {
        let renderValue = "";

        if (object.get('message')) {
          value = object.get('message');

          renderValue = value.substr(0, 50).trim() + (value.length <= 50 ? "" : "...");
        }

        return renderValue;
      }
    },
    {
      columnName: "error_data",
  		type: "string",
      render: ({
        value,
        column,
        getTableData,
        object
      }) => {
        let renderValue = "";

        if (object.get('error_data')) {
          value = object.get('error_data');
          
          renderValue = value.substr(0, 50).trim() + (value.length <= 50 ? "" : "...");
        }

        return renderValue;
      }
    },
    {
      columnName: "code",
  		type: "string"
    },
    {
      columnName: "lineNumber",
  		type: "string"
    },
    {
      columnName: "stack",
  		type: "string",
      render: ({
        value,
        column,
        getTableData,
        object
      }) => {
        let renderValue = "";

        if (object.get('stack')) {
          value = object.get('stack');

          renderValue = value.substr(0, 50).trim() + (value.length <= 50 ? "" : "...");
        }

        return renderValue;
      }
    },
    {
      columnName: "name",
  		type: "string"
    },
    {
      columnName: "createdAt",
      columnLabel: "Date",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A",
      show: true
    },
    {
      columnName: "updatedAt",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A"
    }
  ]
}


// WEBPACK FOOTER //
// ./components/Logs/VoucherErrorLog_schema.js